import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"width":"90vw","margin-left":"auto","margin-right":"auto"} }
const _hoisted_2 = { class: "list-unstyled" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserBlock = _resolveComponent("UserBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dtoFollow.followList, (dtoUser) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "card-header",
          style: {"padding-left":"0","padding-top":"0.25rem","padding-right":"0","padding-bottom":"0.25rem","background-color":"#fff"},
          key: dtoUser.id
        }, [
          _createVNode(_component_UserBlock, { dtoUser: dtoUser }, null, 8, ["dtoUser"])
        ]))
      }), 128))
    ])
  ]))
}